import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-85ffb4a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt"
}
const _hoisted_2 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_3 = { class: "bi-tmpl-detail__right__cmpt__title" }
const _hoisted_4 = { style: {"display":"flex","gap":"32px"} }
const _hoisted_5 = { class: "bi-card-content" }
const _hoisted_6 = { style: {"font-size":"22px","color":"#e8e8e8"} }

import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { BaseCard, BaseSwitch, BaseRadio } from 'xrk-components';
import { addWaterMark } from '@V/bi-tmpl/src/utils/water-mark';
import { uploadApi } from '@data-source/common/apis';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import appStore from '@/store';
import { IS_PLATFORM_TYPE_1 } from '@/config';

const CHILD_KEY = '101_5';

const COMMON_WATER_URL =
  'https://cdn.yxvzb.com/sunflower/bi/watermark/common.png';

export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-101-5',
  props: ['disabled'],
  setup(__props) {



const { info } = storeToRefs(appStore.useUserStoreSetup);
const { curItem, onChange, onClear } = useDetailCmpt({ childKey: CHILD_KEY });

const enterpriseName = info.value.entpName;
const enterpriseId = info.value.entpId;
const createWaterImg = () => {
  // 测试图片加载
  const img = new Image();
  img.src = `https://cdn.yxvzb.com/sunflower/bi/watermark/enterprise_${enterpriseId}.png`;
  img.onerror = async () => {
    // cdn没有该企业水印图
    // 上传水印图到cdn
    const data = await addWaterMark({
      text: enterpriseName,
      density: Math.abs(15 - enterpriseName.length),
      fileName: `enterprise_${enterpriseId}.png`
    });
    // url：https://cdn.yxvzb.com/sunflower/bi/watermark/enterprise_${id}.png
    // 将url给到TYPE_MAPPING[2].originImg
    const {
      data: { fileUrl }
    } = await uploadApi({ file: data.newFile });
    TYPE_MAPPING[2].originImg = fileUrl;
  };
  img.onload = () => {
    TYPE_MAPPING[2].originImg = img.src;
  };
};
onMounted(() => {
  createWaterImg();
});
const TYPE_MAPPING = {
  1: {
    originImg: COMMON_WATER_URL,
    scaleImg:
      'https://cdn.yxvzb.com/sunflower/bi/watermark/common_thumbnail.png'
  },
  2: {
    originImg: curItem.value === COMMON_WATER_URL ? '1' : curItem.value || '1', // 写死一个不存在的值，防止匹配到空字符串
    scaleImg: '1'
  }
};

const onChangeWaterMaker = originImg => {
  onChange(originImg);
};

const onOpenWaterMaker = e => {
  curItem.show = e;
  if (e) {
    onChange(TYPE_MAPPING[2].originImg);
  } else {
    onClear();
  }
};

return (_ctx: any,_cache: any) => {
  return (_unref(IS_PLATFORM_TYPE_1))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(curItem).title), 1),
          _createElementVNode("span", null, [
            _createTextVNode(" 是否开启水印 "),
            _createVNode(_unref(BaseSwitch), {
              disabled: __props.disabled,
              onChange: onOpenWaterMaker,
              "model-value": _unref(curItem).show
            }, null, 8, ["disabled", "model-value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(BaseCard), {
            class: "bi-card",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onChangeWaterMaker(TYPE_MAPPING[2].originImg)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(enterpriseName)), 1),
                _createVNode(_unref(BaseRadio), {
                  value: TYPE_MAPPING[2].originImg,
                  "model-value": _unref(curItem).value
                }, null, 8, ["value", "model-value"])
              ])
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})